import axios from "axios";
import Cookies from "universal-cookie";
import {config} from "./api";

const cookies = new Cookies();

export const authApi = axios.create(config)

authApi.interceptors.request.use(
	(config) => {
		if (!config.withoutAuth) {
			config.headers.Authorization = `Bearer ${cookies.get('builderToken') ? cookies.get('builderToken') : cookies.get('accessToken')}`;
		}
		return config
	},

	(error) => Promise.reject(error.response)
)

authApi.interceptors.response.use(
	response => response.data,
	error => Promise.reject(error.response),
)

export default authApi
